import React from 'react';
import { CreateChildModal } from '../../styleguide/ChildModal';
import axios from "axios";

export default class KidFrameDetail extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      addChildModalOpened: false,
      addChildErrorMessage: '',
    };

    if(!window.kidframe)
    window.kidframe = {};
    window.kidframe['openAddChildModal'] = this.openAddChildModal;
  }

  openAddChildModal = (callback) =>  {
    this.setState({
      addChildModalOpened: true,
    });
    if (callback) {
      this.callback = callback;
    }
  };

  closeAddChildModal = () => {
    this.setState({
      addChildModalOpened: false,
    });
  };

  addChildCallback = (fields, done) => {
    if(this.callback) {
      this.callback({
        ...fields,
        avatar: { internalName: fields.avatar }
      });
    }

    if (this.state.addChildRequestStarted) {
      return false;
    }
    if (!fields.name.length || fields.name.trim() === '') {
      this.setState({
        addChildErrorMessage: "Please enter your child's name"
      });
      return false;
    }

    this.setState({
      addChildRequestStarted: true,
      addChildErrorMessage: '',
      addChildModalOpened: false,
    });

    if(done) done();

    // todo: make a new clean endpoint that matches our data structure and supports grade locking/hiding. see editChild for example.
    let data = {
      childName: fields.name,
      childAvatar:  fields.avatar,
      childGrade: fields.grade,
      verbose: 1
    };

    document.querySelector('#game_holder').contentWindow.addChildStarted();

    axios.post('/api/child', data, {}).then((resp) => {
      if (resp.status) {
        if(resp.avatar.internal_name){
          resp.avatar.internalName = resp.avatar.internal_name;
        }
        let player = {
          PlayerId: resp.PlayerId,
          PlayerName: resp.PlayerName,
          PlayerGrade: resp.PlayerGrade,
          avatar: resp.avatar
        };

        this.setState({
          addChildRequestStarted: false,
          addChildModalOpened: false,
        });

        document.querySelector('#game_holder').contentWindow.addedChild(player);
      }
    }).catch((error) => {
      this.setState({
        addChildRequestStarted: false,
        addChildModalOpened: true,
      });

      document.querySelector('#game_holder').contentWindow.addedChildError();

      if (error.response) {
        this.setState({
          addChildErrorMessage: error.response.data.error.message,
        });
      } else if (error.request) {
        this.setState({
          addChildErrorMessage: 'There was an error with your request and we were unable to add your child.',
        });
      } else {
        this.setState({
          addChildErrorMessage: 'An error happened and we were unable to add your child.',
        });
      }
    });
  };

  render(){
    return (
    <div>
      <CreateChildModal
        key="addChildModal"
        open={this.state.addChildModalOpened}
        error={this.state.addChildErrorMessage}
        onClose={this.closeAddChildModal}
        onSubmit={this.addChildCallback}
      />
    </div>)}
}
